module.exports = __webpack_public_path__ + "static/rottnest-8bc9f1303cfb0ef3aaf78471fbacf994.jpg";